// Copyright (c) Docugami, Inc. All rights reserved.

import { Config } from "config";
import { createDgBaseQuery } from "store/baseQuery";
import { createApi } from '@reduxjs/toolkit/query/react'

export interface GetUserProfileState {
    given_name: string;
    family_name: string;
}

type SetUserProfileRequest = GetUserProfileState
type AuthOUserInfo = GetUserProfileState

const auth0BaseQuery = createDgBaseQuery(`https://${Config.auth0.domain}`, { disableOrganizationIdHeader: true });
const frontendApiQuery = createDgBaseQuery(`${Config.apiUrl}`);

export const auth0UserApiSlice = createApi({
    reducerPath: 'auth0UserApi',
    baseQuery: auth0BaseQuery,
    tagTypes: ['UserProfile'],
    endpoints: builder => ({
        getUserProfile: builder.query<GetUserProfileState, void>({
            query: () => "/userinfo",
            providesTags: (result) => [{ type: 'UserProfile' }],
            transformResponse: (result: AuthOUserInfo): GetUserProfileState => {
                return {
                    given_name: result.given_name,
                    family_name: result.family_name,
                }
            }
        }),
        setUserProfile: builder.mutation<any, SetUserProfileRequest>({
            queryFn: (arg, api, extraOptions, baseQuery) => frontendApiQuery(
                    {
                        url: '/user',
                        body: arg,
                        method: 'PATCH'
                    },
                    api,
                    extraOptions),
            invalidatesTags: ['UserProfile'],
        }),
    })
})

export const {
    useGetUserProfileQuery,
    useSetUserProfileMutation,
} = auth0UserApiSlice;
